import { render, staticRenderFns } from "./AnalyticsSale.vue?vue&type=template&id=5c4edecb&scoped=true"
import script from "./AnalyticsSale.vue?vue&type=script&lang=js"
export * from "./AnalyticsSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4edecb",
  null
  
)

export default component.exports